// extracted by css-extract-rspack-plugin
export default {"tableContainer":"RemunerationInfomation__tableContainer--RpCK_","table":"RemunerationInfomation__table--qZDkK"};